import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch State List Data
export const fetchStateList = createAsyncThunk(
  "state/fetchStateList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/location/panel/StateList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add State to the List
export const addStateList = createAsyncThunk(
  "state/addStateList",
  async (newStateData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/StateList", newStateData);
      alertSuccess(response.data.success);
      return newStateData;
    } catch (error) {
      console.log(error.message);
      alertError(error.response.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update State List Data
export const updateStateList = createAsyncThunk(
  "state/updateStateList",
  async (stateData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/StateList", stateData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// State List Slice
const stateSlice = createSlice({
  name: "state",
  initialState: {
    stateList: [],
    stateId: null, // <-- Added stateId here
    status: "idle",
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setStateId: (state, action) => {
      state.stateId = action.payload;
    },
    clearStateId: (state) => {
      state.stateId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch State List
      .addCase(fetchStateList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchStateList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.stateList = action.payload;
      })
      .addCase(fetchStateList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add State
      .addCase(addStateList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addStateList.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.stateList.push(action.payload);
      })
      .addCase(addStateList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update State List
      .addCase(updateStateList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateStateList.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateStateList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError, setStateId, clearStateId } = stateSlice.actions;

export default stateSlice.reducer;
